import hk from '../Assets/i18n/hk.json'
import en from '../Assets/i18n/hk.json'

export function returnTran(parent, child) {
    if(localStorage.getItem("i18n-lang") === 'en' ){
        return en[parent][child]
    }
    else{
        return hk[parent][child]
    }
}